import { d as e } from "./index-21b082e6.js";
import "./en-4402d6fc.js";
var m = {
  name: "ar-ly",
  weekdays: "الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),
  months: "يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split("_"),
  weekStart: 6,
  weekdaysShort: "أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت".split("_"),
  monthsShort: "يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split("_"),
  weekdaysMin: "ح_ن_ث_ر_خ_ج_س".split("_"),
  ordinal: function(_) {
    return _;
  },
  meridiem: function(_) {
    return _ > 12 ? "م" : "ص";
  },
  formats: {
    LT: "HH:mm",
    LTS: "HH:mm:ss",
    L: "D/‏M/‏YYYY",
    LL: "D MMMM YYYY",
    LLL: "D MMMM YYYY HH:mm",
    LLLL: "dddd D MMMM YYYY HH:mm"
  }
};
e.locale(m, null, !0);
export {
  m as default
};
